module.exports = __webpack_public_path__ + "img/provider1.f80d9503.png";